import { type ReactNode } from 'react';

interface UtilityClassProps {
    className: string;
    example?: ReactNode;
}

export const UtilityClass = ({ className, example = undefined }: UtilityClassProps) => (
    <div className="sds_example__container">
        <div style={{ width: '30%' }} className="sds_token__text__name">
            {className}
        </div>
        <div style={{ width: '70%' }} className="sds_token__example">
            {example}
        </div>
    </div>
);
